// Decimal money helpers. All monetary math goes through decimal.js; values are rounded half-up
// to cents only at presentation/persistence boundaries (explicit rounding rule).
import Decimal from 'decimal.js';

Decimal.set({ precision: 34, rounding: Decimal.ROUND_HALF_UP });

export type Num = Decimal.Value | null | undefined;
export const D = (v: Num) => new Decimal(v === null || v === undefined || v === '' ? 0 : v);
export const cents = (v: Num) => D(v).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
export const toMoney = (v: Num) => cents(v).toFixed(2);
export const sum = (vals: Num[]) => vals.reduce<Decimal>((a, v) => a.plus(D(v)), new Decimal(0));
/** Safe ratio; returns null when the denominator is zero (undefined index, not zero). */
export const ratio = (a: Num, b: Num): Decimal | null => (D(b).isZero() ? null : D(a).div(D(b)));
export { Decimal };
